(function () {
    'use strict';

    /*
     * Copyright (c) 2017-19 In Hand Health.
     * All rights reserved.
     */

    angular
        .module('ihh-common-web')
        .controller('CampaignResourceMaterialCtrl', CampaignResourceMaterialCtrl);

    CampaignResourceMaterialCtrl.$inject = ['$scope', '$routeParams', '$modal', 'Utilities', 'RestResources', 'CampaignConstants',
        'CampaignResourceMaterialsConstants',
        'ResourceMaterialsFactory', 'IhhModalItemChooser', '_', 'EpisodeTemplateService'];

    function CampaignResourceMaterialCtrl ($scope, $routeParams, $modal, Utilities, RestResources, CampaignConstants,
        CampaignResourceMaterialsConstants,
        ResourceMaterialsFactory, IhhModalItemChooser, _, EpisodeTemplateService) {
        var vm = this;
        var campaignId = $routeParams.campaignId;
        var episodeTemplateId = vm.episodeModel.id;

        vm.templateStrings = CampaignResourceMaterialsConstants.templateStrings;
        vm.chooseResourceMaterial = chooseResourceMaterial;
        vm.getResourceMaterialThumbnailUrl = getResourceMaterialThumbnailUrl;
        vm.resources;
        vm.getMediaUrl = getMediaUrl;
        vm.getUrl = getUrl;
        vm.displayVideoPreview = displayVideoPreview;
        vm.removeEpisodeResourceMaterial = removeEpisodeResourceMaterial;

        activate();

        function activate() {
            displayBusyIndicator();

            vm.resourceMaterialsCrud.query(campaignId, episodeTemplateId).then(function (result) {
                vm.resources = result.items;
                _.each(vm.resources, function(item) {
                    item.resourceMaterial.typeLabel = ResourceMaterialsFactory.getTypeLabel(item.resourceMaterial);
                });
            }, function (err) {
                RestResources.reportRestError(err);
            }).finally(function() {
                hideBusyIndicator();
            });
        }

        function chooseResourceMaterial() {
            vm.resourceMaterialsConfig.setSelectedFn(function(item) {
                displayBusyIndicator();

                vm.resourceMaterialsCrud.save(campaignId, episodeTemplateId, item).then(function (result) {
                    result.resourceMaterial.typeLabel = ResourceMaterialsFactory.getTypeLabel(result.resourceMaterial);
                    vm.resources.unshift(result);
                }, function (err) {
                    RestResources.reportRestError(CampaignResourceMaterialsConstants.resources.add.errorString, err);
                }).finally(function () {
                    hideBusyIndicator();
                });

            });

            vm.resourceMaterialsConfig.maintainState($scope);

            IhhModalItemChooser.open(vm.resourceMaterialsConfig);
        }

        function getMediaUrl (item) {
            return RestResources.getResourceMaterialMediaUrl(item, item.mediaName);
        }

        function getUrl (url) {
            var validUrl = url;

            if (Utilities.isDefinedAndNotNull(url) && url.indexOf('://') < 0) {
                validUrl = "http://" + url;
            }

            return validUrl;
        }

        function displayVideoPreview (event, item) {
            event.stopPropagation();
            $modal.open({
                templateUrl: 'app/patients/patient/episodes/episode/resource-materials/episode-resource-material-modal.tpl.html',
                controller: 'EpisodeResourceMaterialModalCtrl',
                controllerAs: 'EpisodeResourceMaterialModalCtrlVm',
                bindToController: true,
                resolve: {
                    selectedItem: function () {
                        return item;
                    }
                }
            });
        }

        function removeEpisodeResourceMaterial (episodeResourceMaterial) {
            displayBusyIndicator();

            Utilities.confirmDialog(CampaignConstants.resources.remove.confirmText, function() {
                vm.resourceMaterialsCrud.remove(campaignId, episodeTemplateId, episodeResourceMaterial.id).then(function () {
                    _.remove(vm.resources, function (i) {
                        return i.id === episodeResourceMaterial.id;
                    });
                }, function (err) {
                    RestResources.reportRestError(CampaignConstants.resources.remove.errorString, err);
                }).finally(function () {
                    hideBusyIndicator();
                });
            }, function () {
                hideBusyIndicator();
            });
        }

        function getResourceMaterialThumbnailUrl(item) {
            return RestResources.getResourceMaterialThumbnailUrl(item);
        }

        // uses a promise to display the busy indicator
        function displayBusyIndicator () {
            EpisodeTemplateService.displayBusyIndicator();
        }

        // clears the promise so that the busy indicator will no longer be displayed
        function hideBusyIndicator () {
            EpisodeTemplateService.hideBusyIndicator();
        }
    }
})();